import { Suspense, lazy, useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "bootstrap/dist/css/bootstrap.min.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import InstitutionServicesBanner from "./components/InstitutionServicesBanner";
import PageAdPlacements from "./components/PageAdPlacements";
import ScrollToTop from "./components/ScrollToTop";
import RouteSkeleton from "./components/RouteSkeleton";
import AppRoutes from "./routes/AppRoutes";

// const FloatingChatbot = lazy(() => import("./components/FloatingChatbot"));
const FloatingWhatsApp = lazy(() => import("./components/FloatingWhatsApp"));

function App() {
  const [enableChatbot, setEnableChatbot] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const activate = () => setEnableChatbot(true);

    if ("requestIdleCallback" in window) {
      const id = window.requestIdleCallback(activate, { timeout: 2500 });
      return () => window.cancelIdleCallback(id);
    }

    const timer = setTimeout(activate, 2500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Navbar />
        <PageAdPlacements position="top" />

        <Suspense fallback={<RouteSkeleton />}>
          <AppRoutes />
        </Suspense>

        <PageAdPlacements position="bottom" />

        {/* {enableChatbot ? (
          <Suspense fallback={null}>
            <FloatingChatbot />
          </Suspense>
        ) : null} */}
        
        {enableChatbot ? (
          <Suspense fallback={null}>
            <FloatingWhatsApp />
          </Suspense>
        ) : null}

        <InstitutionServicesBanner />
        <Footer />
      </Router>
    </HelmetProvider>
  );
}

export default App;
